import { render, staticRenderFns } from "./PatientOrthoSpaceDetail.vue?vue&type=template&id=1b4e8894&"
import script from "./PatientOrthoSpaceDetail.vue?vue&type=script&lang=js&"
export * from "./PatientOrthoSpaceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports